import api from "./api";
import { CERTIFICATIONS } from "../utils/constants";

const certificateService = {
  // Get all certificates
  getCertificates: async () => {
    const response = await api.get(CERTIFICATIONS.BASE);
    return response.data;
  },

  // Get certificate by ID
  getCertificateById: async (certificateId) => {
    const response = await api.get(`${CERTIFICATIONS.BASE}/${certificateId}`);
    return response.data;
  },

  // Generate a new certificate
  generateCertificate: async (studentId, courseId, certificateData) => {
    const response = await api.post(
      CERTIFICATIONS.GENERATE(studentId, courseId),
      certificateData
    );
    return response.data;
  },


  downloadCertificate: async (serialNumber) => {
    try {
      console.log('Attempting to download certificate:', serialNumber);
      
      const response = await api.get(`http://localhost:5000/api/certifications/download/${serialNumber}`, {
        responseType: 'blob', // Ensure we get binary data
        headers: {
          'Accept': 'application/pdf',
        }
      });
  
      console.log('Download response:', response);
  
      // Create a downloadable link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${serialNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download error details:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        headers: error.response?.headers
      });
      throw error;
    }
  },
  

  // Verify certificate by serial number
  verifyCertificate: async (serialNumber) => {
    const response = await api.get(CERTIFICATIONS.VERIFY(serialNumber));
    return response.data;
  },

  // Update certificate (e.g., revoke or update metadata)
  updateCertificate: async (certificateId, certificateData) => {
    const response = await api.patch(
      `${CERTIFICATIONS.BASE}/${certificateId}`,
      certificateData
    );
    return response.data;
  },

  // Delete certificate
  deleteCertificate: async (certificateId) => {
    const response = await api.delete(
      `${CERTIFICATIONS.BASE}/${certificateId}`
    );
    return response.data;
  },
};

export default certificateService;
